<div
  class="form-group {{ config.toggleParrentClassName }}"
  [formGroup]="group"
  [ngClass]="{
    'form-error':
      (groupControl.errors && groupControl.dirty && groupControl.touched) ||
      groupControl.hasError('max') ||
      groupControl.hasError('maxlength') ||
      groupControl.hasError('min') ||
      groupControl.hasError('minlength') ||
      groupControl.hasError('pattern')
  }"
>
  <!-- checkbox - this is a special case that needs to come before the common markup due to the styleguide -->
  <div *ngIf="config.type === 'checkbox'" class="form-group-checkbox">
    <input
      [id]="config.name"
      type="checkbox"
      [required]="config.required"
      [formControlName]="config.name"
      class="form-checkbox"
      [attr.disabled]="isDisabled$ | async"
      bomAutofocusable
    />
    <label class="form-label" [for]="config.name">
      {{ config.label }}
      <span
        class="form-hint-no-newline"
        *ngIf="
          config.defaultValue !== null &&
          config.defaultValue !== undefined &&
          config.recommendedText
        "
      >
        {{ config.recommendedText }}
      </span>
    </label>
    <span *ngIf="config.hoverText" [title]="config.hoverText">
      <svg class="icon-svg">
        <use xlink:href="#help-circle-outline"></use>
      </svg>
    </span>
    <span [ngClass]="{ required: config.required }"></span>
  </div>

  <!-- common markup -->
  <label
    *ngIf="config.type !== 'checkbox'"
    class="form-label"
    [ngClass]="{ required: config.required }"
    [for]="config.name"
    [displayType]
  >
    {{ config.label }}
    <!-- can make use of the recommendedText variable in the XML if needed
    <span
      class="form-hint"
      *ngIf="(config.type === 'input' || config.type === 'textarea') && config.defaultValue && config.recommendedText"
    >
      {{ config.recommendedText }}
    </span> -->
  </label>
  <span *ngIf="config.hoverText" [title]="config.hoverText">
    <svg class="icon-svg">
      <use xlink:href="#help-circle-outline"></use>
    </svg>
  </span>
  <span *ngIf="config.helpText" class="form-hint">{{ config.helpText }}</span>

  <div *ngIf="groupControl.dirty && groupControl.touched">
    <span
      *ngIf="groupControl.hasError('required') || groupControl.hasError('trimRequired')"
      class="form-error-message"
      role="alert"
    >
      {{ 'Validering.Required' | tekstresource }}
    </span>
  </div>

  <!-- Always show these types of validation errors -->
  <span *ngIf="groupControl.hasError('max')" class="form-error-message" role="alert">
    {{ 'Validering.Max' | tekstresource: config }}
  </span>
  <span *ngIf="groupControl.hasError('maxlength')" class="form-error-message" role="alert">
    {{ 'Validering.MaxLength' | tekstresource: config }}
  </span>
  <span *ngIf="groupControl.hasError('min')" class="form-error-message" role="alert">
    {{ 'Validering.Min' | tekstresource: config }}
  </span>
  <span *ngIf="groupControl.hasError('minlength')" class="form-error-message" role="alert">
    {{ 'Validering.MinLength' | tekstresource: config }}
  </span>
  <span *ngIf="groupControl.hasError('pattern')" class="form-error-message" role="alert">
    {{ 'Validering.Pattern' | tekstresource }}
  </span>

  <div [ngClass]="{ 'row align-items-end': showHentFraMinProfilButton }">
    <!-- type specific fields -->
    <ng-container [ngSwitch]="config.type">
      <!-- textbox -->
      <ng-container *ngSwitchCase="'input'">
        <!-- no inputType set -->
        <input
          *ngIf="!config.inputType"
          [id]="config.name"
          type="text"
          class="form-input"
          [formControlName]="config.name"
          [attr.placeholder]="config.placeholder"
          [required]="config.required"
          [attr.disabled]="isDisabled$ | async"
          [autocomplete]="config.autocomplete"
          bomAutofocusable
        />
        <!-- inputType address -->
        <bom-dawa-adresse-form-input
          *ngIf="config.inputType === 'address'"
          class="dawa-adresse-form-input"
          [id]="config.name"
          [formControlName]="config.name"
          [form]="group"
          [placeholder]="config.placeholder"
          [isRequired]="config.required"
          [isDisabled]="isDisabled$ | async"
          bomAutofocusable
        >
        </bom-dawa-adresse-form-input>
      </ng-container>
      <!-- radio -->
      <ng-container *ngSwitchCase="'radio'">
        <div *ngFor="let item of config.items">
          <input
            [id]="config.name + item.name"
            type="radio"
            class="form-radio"
            [formControlName]="config.name"
            [attr.name]="config.name"
            [value]="item.value"
            [attr.disabled]="isDisabled$ | async"
            bomAutofocusable
          />
          <label class="form-label" [for]="config.name + item.name">
            {{ item.name }}
            <span
              class="form-hint-no-newline"
              *ngIf="config.defaultValue === item.value && config.recommendedText"
            >
              {{ config.recommendedText }}
            </span>
          </label>
        </div>
      </ng-container>
      <!-- checkbox - only inserted to reflect having handled the checkbox type already -->
      <ng-container *ngSwitchCase="'checkbox'"></ng-container>
      <!-- textarea -->
      <div *ngSwitchCase="'textarea'" class="mt-3">
        <bom-rich-text-editor
          [formControlName]="config.name"
          bomAutofocusable
          [placeholder]="config.placeholder"
          [isDisabled]="isDisabled$ | async"
        ></bom-rich-text-editor>
      </div>
      <!-- select -->
      <select
        *ngSwitchCase="'select'"
        [id]="config.name"
        class="form-select"
        [formControlName]="config.name"
        [required]="config.required"
        [attr.disabled]="isDisabled$ | async"
        bomAutofocusable
      >
        <option *ngFor="let item of config.items" [value]="item.value">
          {{ item.name }}
          <span *ngIf="config.defaultValue === item.value && config.recommendedText">
            {{ config.recommendedText }}
          </span>
        </option>
      </select>
      <!-- table -->
      <table *ngSwitchCase="'table'" class="table table--compact mt-3">
        <thead>
          <tr>
            <th *ngFor="let col of config.columnDefinitions">
              <div class="d-flex justify-content-between">
                <div>{{ col.displayName }}</div>
                <div *ngIf="col.helpText">
                  <bom-info-icon [content$]="col.helpText"></bom-info-icon>
                </div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody [formGroupName]="config.name">
          <tr *ngFor="let row of config.rows" [formGroupName]="row.id">
            <td *ngFor="let cell of row.cells" class="cell-K1">
              <div *ngIf="cell.columnId == 'K2' && cell.readOnly; else cellReadOnly">
                <div
                  *ngIf="
                    cell?.choice && cell?.choice?.valueDisplayString == notValid;
                    else inputBlockReadOnly
                  "
                >
                  <select
                    [id]="cell.choice.id"
                    class="form-select cell-select-readonly"
                    [attr.disabled]="cell.readOnly"
                    [formControlName]="cell.columnId"
                  >
                    <option *ngFor="let item of cell.choice.items" [value]="item.value">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>

              <ng-template #cellReadOnly>
                <div *ngIf="cell.readOnly; else cellNotReadOnly" [title]="cell.value">
                  {{ cell.value }}
                  <span *ngIf="cell.helpText" [title]="cell.helpText">
                    <svg class="icon-svg">
                      <use xlink:href="#help-circle-outline"></use>
                    </svg>
                  </span>
                </div>
              </ng-template>

              <ng-template #cellNotReadOnly>
                <div
                  *ngIf="
                    cell?.choice && cell?.choice?.valueDisplayString == notValid;
                    else inputBlock
                  "
                >
                  <select
                    [id]="cell.choice.id"
                    class="form-select cell-select"
                    [attr.disabled]="isDisabled$ | async"
                    bomAutofocusable
                    [formControlName]="cell.columnId"
                  >
                    <option *ngFor="let item of cell.choice.items" [value]="item.value">
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </ng-template>

              <ng-template #inputBlock>
                <input
                  type="text"
                  class="form-input cell-input"
                  [formControlName]="cell.columnId"
                  [placeholder]="cell.placeHolder"
                  [title]="cell.value"
                  [attr.disabled]="isDisabled$ | async"
                />
                <span>{{ cell.status }}</span>
                <span
                  *ngIf="groupControlForCell(cell.rowId).hasError('pattern'); then patternError"
                ></span>
                <span
                  *ngIf="groupControlForCell(cell.rowId).hasError('maxlength'); then maxlengthError"
                ></span>
                <ng-template #patternError
                  ><span class="form-error-message" style="padding-left: 1.5rem">{{
                    'KunHeltalFejlBesked' | tekstresource
                  }}</span></ng-template
                >
              </ng-template>
              <ng-template #maxlengthError
                ><span class="form-error-message" style="padding-left: 1.5rem">{{
                  'Maks200Karakterer' | tekstresource
                }}</span></ng-template
              >

              <ng-template #inputBlockReadOnly>
                <input
                  type="text"
                  class="cell-input"
                  [title]="cell.value"
                  [value]="cell.value"
                  readonly
                />
              </ng-template>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- default / unhandled -->
      <div *ngSwitchDefault class="text-negative">
        WARNING: Unhandled element type: {{ config.type }}
      </div>
    </ng-container>
    <ng-container *ngIf="showHentFraMinProfilButton">
      <div class="pl-5">
        <ng-template [ngTemplateOutlet]="hentFraMinProfilButton"></ng-template>
      </div>
    </ng-container>
  </div>
</div>
